import type { CustomCellRendererProps } from "ag-grid-react";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { RecalProposalSetConstant } from "./RecalProposalSetConstant";

const RECAL_PROPOSAL_SET_CONSTANT = RecalProposalSetConstant.DtlTable;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const INITIAL_RECAL_PROPOSAL_SET_DTL_COL_DEF_FOR_SAPT: any[] = [

    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.COMPANY_CODE,
        field: "companyCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
        checkboxSelection: true,
        headerCheckboxSelection: true,
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.COMPANY_TYPE,
        field: "companyType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.PROPOSAL_NO,
        field: "proposalNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.EFFECTIVE_DATE,
        field: "effectiveDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "date"
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.EXPIRY_DATE,
        field: "expiryDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "date"
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.CREATED_BY,
        field: "createdBy",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.CREATED_DATE,
        field: "createdDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "date"
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const INITIAL_RECAL_PROPOSAL_SET_DTL_COL_DEF: any[] = [

    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.COMPANY_CODE,
        field: "companyCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
        checkboxSelection: true,
        headerCheckboxSelection: true,
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.COMPANY_TYPE,
        field: "companyType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.PROPOSAL_NO,
        field: "proposalNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.EFFECTIVE_DATE,
        field: "effectiveDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "date"
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.CREATED_BY,
        field: "createdBy",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: RECAL_PROPOSAL_SET_CONSTANT.CREATED_DATE,
        field: "createdDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "date"
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}